<template>
  <div>
    <v-menu
      ref="date_menu"
      v-model="date_menu"
      :return-value.sync="date_pick"
      :close-on-content-click="false"
      min-width="320px"
      max-width="350px"
      nudge-bottom="10"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          outlined
          :label="label"
          :prepend-icon="show_icon ? 'mdi-calendar' : ''" 
          readonly
          v-on="on"
          :value="show_formated_date" :rules="required"
          :class="alternative_class"
          :style="alternative_style"
          :solo="solo"
          v-bind="$attrs"
        ></v-text-field>
      </template>
      <v-date-picker
        :show-current="show_current"
        v-model="date_pick"
        no-title
        scrollable
        full-width
        :min="min || min_date"
        :max="max"
        :rules="required"
      >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="date_menu = false"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="$refs.date_menu.save(date_pick)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import validations from "@/mixins/validations";

export default {
  name: 'CalendarDatePicker',
  mixins: [ validations ],
  props: {
    item: {
      type: Object,
    },
    label: {
      type: String,
    },
    max: {
      type: String,
    },
    min: {
      type: String,
    },
    show_current: {
      type: String
    },
    show_icon: {
      type: Boolean,
      default: true
    },
    alternative_class: {
      type: String,
      default: () => ''
    },
    alternative_style: {
      type: String,
      default: () => ''
    },
    solo: {
      type: Boolean,
      default: false
    },
    date: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      date_pick: '',
      date_menu: false,
      min_date: this.$dayjs().format('YYYY-MM-DD'),
    }
  },
  computed: {
    show_formated_date(){
      return this.date_pick != '' ? this.$dayjs(this.date_pick).format('DD/MM/YYYY') 
                                  : this.date ? this.$dayjs(this.date).format('DD/MM/YYYY')
                                  : null
    },
  },
  watch: {
    date_pick(nV) {
      if(this.item){
        let item = {...this.item}
        item.date = nV
        this.$emit('datePicked', item )
      }else{
        this.$emit('datePicked', nV )
      }
    },
    max(){
      if(this.$dayjs(this.date_pick).isAfter(this.max)){
        this.date_pick = ''
      }
    },
    min(){
      if(this.$dayjs(this.date_pick).isBefore(this.min)){
        this.date_pick = ''
      }
    },
  },

}
</script>

<style lang="scss" scoped>

</style>